import React from 'react';
import { Disclosure } from '@headlessui/react';
import { MenuAlt4Icon, XIcon } from '@heroicons/react/outline';
import { Link } from 'gatsby';

import NavbarDropdown from './navbar-dropdown';
import Search from './search';
const searchIndices = [{ name: `episodes`, title: `episodes` }];

import { officialLinks } from '../data/official-links';

const navigation = [
  {
    label: 'Episodes',
    href: '/episodes/',
  },
  {
    label: 'Categories',
    href: '/categories/',
  },
  {
    label: 'Books',
    href: '/books/',
  },
  {
    label: 'Stats',
    href: '/stats/',
  },
  {
    label: 'Articles',
    href: '/articles/',
  },
  {
    label: 'Schedule',
    href: '/schedule/',
  },
];

const dropdownData = [
  {
    label: 'Website',
    href: officialLinks.podcastWebsite,
  },
  {
    label: 'YouTube playlist',
    href: officialLinks.youtubePlaylist,
  },
  {
    label: 'Apple Podcasts',
    href: officialLinks.applePodcasts,
  },
  {
    label: 'Google Podcasts',
    href: officialLinks.googlePodcasts,
  },
  {
    label: 'Spotify',
    href: officialLinks.spotify,
  },
  {
    label: 'RSS',
    href: officialLinks.rss,
  },
  {
    label: 'Patreon',
    href: officialLinks.patreon,
  },
  {
    label: "Lex's homepage",
    href: officialLinks.homepage,
  },
  {
    label: 'Lex Fridman on YouTube',
    href: officialLinks.lexfridmanYoutube,
  },
  {
    label: 'Lex Clips on YouTube',
    href: officialLinks.lexclipsYoutube,
  },
  {
    label: 'Lex on Reddit',
    href: officialLinks.redditUsername,
  },
  {
    label: 'r/lexfridman',
    href: officialLinks.reddit,
  },
  {
    label: 'Lex on Twitter',
    href: officialLinks.twitterUsername,
  },
  {
    label: 'Lex on Instagram',
    href: officialLinks.instagramUsername,
  },
  {
    label: 'Lex on GitHub',
    href: officialLinks.githubUsername,
  },
  {
    label: 'Lex on LinkedIn',
    href: officialLinks.linkedinUsername,
  },
  {
    label: 'Lex on Facebook',
    href: officialLinks.facebookUsername,
  },
  {
    label: 'Lex on TikTok',
    href: officialLinks.tiktokUsername,
  },
];

export default function Navbar() {
  return (
    <div>
      <Disclosure as="nav" className="bg-gray-900 lg:mb-5 md:mt-3">
        {({ open }) => (
          <>
            <div className="max-w-full mx-auto">
              <div className="flex items-center justify-between h-16">
                <div className="flex items-center">
                  <span className="text-5xl mt-1 pb-3 whitespace-nowrap uppercase border-b border-gray-600 text-gradient hover:animate-jelly">
                    <Link to="/" className="logo">
                      LFP <span className="text-4xl">Library</span>
                    </Link>
                  </span>
                  <div className="hidden lg:block">
                    <div className="ml-10 flex items-baseline space-x-4 mt-4 pr-2 pb-1 border-b border-r border-gray-600 rounded-sm">
                      {navigation.map((item) => (
                        <Link
                          key={`nav-item-${item.label}`}
                          to={item.href}
                          className="px-3 py-2 text-lg text-gray-300 hover:text-white"
                          activeClassName="text-gray-400"
                          partiallyActive={true}
                        >
                          {item.label}
                        </Link>
                      ))}
                      <Search indices={searchIndices} />
                    </div>
                  </div>
                </div>
                {/* Links dropdown */}
                <div className="hidden lg:block ml-4 md:ml-6 mt-4 whitespace-nowrap">
                  <NavbarDropdown label="Official links" items={dropdownData} />
                </div>
                {/* Mobile menu button */}
                <div className="-mr-2 flex lg:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 text-gray-300 hover:text-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuAlt4Icon
                        className="block h-6 w-6"
                        aria-hidden="true"
                      />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>

            {/* Mobile menu */}
            <Disclosure.Panel className="lg:hidden border-b border-gray-700">
              <div className="pt-2 pb-3">
                {navigation.map((item, idx) => (
                  <Link
                    key={`mobile-nav-item-${idx}`}
                    to={item.href}
                    className="block py-2 rounded-md text-xl font-medium text-gray-300 hover:text-white"
                    activeClassName="text-gray-400"
                  >
                    {item.label}
                  </Link>
                ))}
                <Search indices={searchIndices} />
              </div>
              <details className="pt-4 pb-3 border-t border-gray-700">
                <summary className="">
                  <span className="text-xl font-medium leading-none cursor-pointer text-gray-300 hover:text-white">
                    Official links
                  </span>
                </summary>
                <ul className="mt-1 px-1 space-y-1">
                  {dropdownData.map((item, idx) => (
                    <a
                      key={`mobile-nav-link-${idx}`}
                      href={item.href}
                      target="blank"
                      className="block px-3 py-2text-xl font-medium text-gray-400 hover:text-white"
                    >
                      {item.label}
                    </a>
                  ))}
                </ul>
              </details>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
